module.exports = __webpack_public_path__ + "img/insigne-bg-stroke-grey.7dd6c3f6.png";